export const Study = {
  Name: "Навчання",
  Emoji: "🗓",
  Button: {
    ADD: "Додати",
  },
};
